var map = {
	"../pages/admin/admin.module.ngfactory": [
		"LfLH",
		1,
		4,
		14
	],
	"../pages/institution/institution.module.ngfactory": [
		"R7MM",
		1,
		7,
		16
	],
	"../pages/plans/plans.module.ngfactory": [
		"t5kX",
		2,
		17
	],
	"../pages/project/project.module.ngfactory": [
		"g5Nn",
		4,
		20
	],
	"../pages/repositories/repositories.module.ngfactory": [
		"uP4b",
		21
	],
	"./configuration/configuration.module.ngfactory": [
		"d8/F",
		15
	],
	"./development/development.module.ngfactory": [
		"Ooi5",
		1,
		3,
		2,
		5,
		7,
		6,
		13
	],
	"./document/document.module.ngfactory": [
		"MG6g",
		3,
		2,
		5,
		18
	],
	"./planning/planning.module.ngfactory": [
		"zcsN",
		3,
		6,
		19
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;